import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Head from "../../elements/head/head";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import api from "../../api";
import TextField from "@mui/material/TextField";
import "./lk.scss";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import { useMask } from "@react-input/mask";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import AvatarEditor from "../../elements/avatar_editor/avatar_editor";
import Avatar from "@mui/material/Avatar";
import { setUnauthorized } from "../../store/userSelector";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_MEDIA } from "../../env";
import Progress from "../../elements/progress/progress";
import Paper from "@mui/material/Paper";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import Footer from "../../elements/footer/footer";

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.body,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Lk = (args) => {
  const token = useSelector((state) => state.userSelector.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [first_name_error, setFirst_name_error] = useState(false);
  const [first_name_error_helper_text, setFirst_name_error_helper_text] =
    useState("");

  const [last_name_error, setLast_name_error] = useState(false);
  const [last_name_error_helper_text, setLast_name_error_helper_text] =
    useState("");

  const [third_name_error, setThird_name_error] = useState(false);
  const [third_name_error_helper_text, setThird_name_error_helper_text] =
    useState("");

  const [email_error, setEmail_error] = useState(false);
  const [email_error_helper_text, setEmail_error_helper_text] = useState("");

  const [bench_error, setBench_error] = useState(false);
  const [bench_error_helper_text, setBench_error_helper_text] = useState("");

  const [press_error, setPress_error] = useState(false);
  const [press_error_helper_text, setPress_error_helper_text] = useState("");

  const [deadlift_error, setDeadlift_error] = useState(false);
  const [deadlift_error_helper_text, setDeadlift_error_helper_text] =
    useState("");

  const [sum_error, setSum_error] = useState(false);
  const [sum_error_helper_text, setSum_error_helper_text] = useState("");

  const [last_name, setLast_name] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [third_name, setThird_name] = useState("");
  const [phone, setPhone] = useState("");
  const [date_birth, setDate_birth] = useState(null);
  const [email, setEmail] = useState("");
  const [razrad, setRazrad] = useState("б/р");
  const [ves_kat, setVes_kat] = useState("53");
  const [bench, setBench] = useState("");
  const [press, setPress] = useState("");
  const [deadlift, setDeadlift] = useState("");
  const [sum, setSum] = useState("");
  const [aboutself, setAboutself] = useState("");
  const [but_dis, setBut_dis] = useState(false);
  const [image, setImage] = useState(null);
  const [avatar, setAvatarPath] = useState("/static/img/avatar/nofoto.jpg");

  const error = (e) => {
    setFirst_name_error(e);
    setLast_name_error(e);
    setThird_name_error(e);
    setBench_error(e);
    setPress_error(e);
    setDeadlift_error(e);
    setSum_error(e);
    setEmail_error(e);
  };
  const error_mes = (e) => {
    setFirst_name_error_helper_text("");
    setLast_name_error_helper_text("");
    setThird_name_error_helper_text("");
    setBench_error_helper_text("");
    setPress_error_helper_text("");
    setDeadlift_error_helper_text("");
    setSum_error_helper_text("");
    setEmail_error_helper_text("");
  };

  const inputRef = useMask({
    mask: "+7(___) ___-__-__",
    replacement: { _: /\d/ },
    showMask: "+0 (123) ___-__-__",
  });
  const Unauthorized = () => {
    dispatch(setUnauthorized());
    window.location.reload();
  };

  const getUser = () => {
    setLoading(true);
    api.getDateUser(token).then((response) => {
      if (response.data.message === "User delete on server") {
        // Unauthorized();
      } else {
        // console.log(token);
        setLast_name(response.data.sportsmen[0].last_name);
        setFirst_name(response.data.sportsmen[0].first_name);
        setThird_name(response.data.sportsmen[0].third_name);
        setPhone(response.data.sportsmen[0].phone);

        setDate_birth(response.data.sportsmen[0].date_birth);
        setEmail(response.data.sportsmen[0].email);
        setRazrad(response.data.sportsmen[0].razrad);
        setVes_kat(response.data.sportsmen[0].ves_kat);

        setBench(response.data.sportsmen[0].bench);
        setPress(response.data.sportsmen[0].press);
        setDeadlift(response.data.sportsmen[0].deadlift);
        setSum(response.data.sportsmen[0].sum);
        setAboutself(response.data.sportsmen[0].aboutself);
        setAvatarPath(API_MEDIA + response.data.sportsmen[0].image);
      }
    });
    setLoading(false);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const Sportsmen = () => {
    const formData = new FormData();
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("email", email);
    formData.append("third_name", third_name);
    formData.append("phone", phone);
    if (date_birth) formData.append("date_birth", date_birth);
    // formData.append("date_birth", date_birth);
    formData.append("razrad", razrad);
    formData.append("ves_kat", ves_kat);
    formData.append("bench", bench);
    formData.append("press", press);
    formData.append("deadlift", deadlift);
    formData.append("sum", sum);
    formData.append("aboutself", aboutself);
    if (image) formData.append("image", image);
    setBut_dis(true);
    api
      .PostSportsmen(token, formData)
      .then((response) => {
        setAvatarPath(response.data["image"]);
        error(false);
        error_mes("");
      })
      .catch((error) => {
        console.error("Ошибка сервера:", error.response.data);
        if (error.response.data["first_name"]) {
          setFirst_name_error(true);
          setFirst_name_error_helper_text(error.response.data["first_name"]);
        }
        if (error.response.data["last_name"]) {
          setLast_name_error(true);
          setLast_name_error_helper_text(error.response.data["last_name"]);
        }
        if (error.response.data["third_name"]) {
          setThird_name_error(true);
          setThird_name_error_helper_text(error.response.data["third_name"]);
        }
        if (error.response.data["email"]) {
          setEmail_error(true);
          setEmail_error_helper_text(error.response.data["email"]);
        }
        if (error.response.data["bench"]) {
          setBench_error(true);
          setBench_error_helper_text(error.response.data["bench"]);
        }
        if (error.response.data["press"]) {
          setPress_error(true);
          setPress_error_helper_text(error.response.data["press"]);
        }
        if (error.response.data["deadlift"]) {
          setDeadlift_error(true);
          setDeadlift_error_helper_text(error.response.data["deadlift"]);
        }
        if (error.response.data["sum"]) {
          setSum_error(true);
          setSum_error_helper_text(error.response.data["sum"]);
        }
      }, setBut_dis(false));
  };

  useEffect(() => {
    getUser(token);
  }, [token, avatar]);
  // useEffect(() => {
  //   getUser();
  // }, [avatar]);
  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={12}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={12} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          <Paper>
            <Grid
              spacing={1}
              container
              direction="rows"
              sx={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid size={12}>
                <Item>ЛИЧНЫЙ КАБИНЕТ</Item>
              </Grid>
              <Grid size={12}>
                <Item>
                  <Divider>РЕГИСТРАЦИОННЫЕ ДАННЫЕ</Divider>
                </Item>
              </Grid>

              <Grid size={12} container>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={last_name}
                      sx={{ width: "100%" }}
                      onChange={(e) => setLast_name(e.target.value)}
                      onfo
                      id="last_name"
                      label="Фамилия"
                      variant="outlined"
                      error={last_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={last_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={first_name}
                      sx={{ width: "100%" }}
                      onChange={(e) => setFirst_name(e.target.value)}
                      onfo
                      id="first_name"
                      label="Имя"
                      variant="outlined"
                      error={first_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={first_name_error_helper_text}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={third_name}
                      sx={{ width: "100%" }}
                      onChange={(e) => setThird_name(e.target.value)}
                      onfo
                      id="third_name"
                      label="Отчество"
                      variant="outlined"
                      error={third_name_error}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={third_name_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onfo
                      id="email"
                      label="Емаил"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={email_error}
                      type="email"
                      slotProps={{ inputLabel: { shrink: true } }}
                      required
                      helperText={email_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      id="phone"
                      value={phone}
                      label="Номер телефона"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={false}
                      inputRef={inputRef}
                      slotProps={{ inputLabel: { shrink: true } }}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Item>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      value={date_birth}
                      onChange={(e) => setDate_birth(e.target.value)}
                      onfo
                      id="date_birth"
                      label="Дата рождения"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={false}
                      type="date"
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                  </Item>
                </Grid>
              </Grid>

              <Grid size={12}>
                <Item>
                  <Divider>СПОРТИВНЫЕ ДОСТИЖЕНИЯ</Divider>
                </Item>
              </Grid>

              <Grid size={12} container>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Разряд
                      </InputLabel>
                      <Select
                        id="razrad"
                        select
                        value={razrad}
                        label="Разряд"
                        onChange={(e) => setRazrad(e.target.value)}
                        error={false}
                        helperText="Выберете значение"
                      >
                        <MenuItem value={"б/р"}>б/р</MenuItem>
                        <MenuItem value={"III ЮН"}>III ЮН</MenuItem>
                        <MenuItem value={"II ЮН"}>II ЮН</MenuItem>
                        <MenuItem value={"I ЮН"}>I ЮН</MenuItem>
                        <MenuItem value={"III"}>III</MenuItem>
                        <MenuItem value={"II"}>II</MenuItem>
                        <MenuItem value={"I"}>I</MenuItem>
                        <MenuItem value={"КМС"}>КМС</MenuItem>
                        <MenuItem value={"МС"}>МС</MenuItem>
                        <MenuItem value={"МСМК"}>МСМК</MenuItem>
                      </Select>
                    </FormControl>
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Весовая категория
                      </InputLabel>
                      <Select
                        id="ves_kat"
                        select
                        value={ves_kat}
                        label="Весовая категория"
                        onChange={(e) => setVes_kat(e.target.value)}
                        error={false}
                        helperText="Выберете значение"
                      >
                        <MenuItem value={"53"}>53</MenuItem>
                        <MenuItem value={"59"}>59</MenuItem>
                        <MenuItem value={"66"}>66</MenuItem>
                        <MenuItem value={"74"}>74</MenuItem>
                        <MenuItem value={"83"}>83</MenuItem>
                        <MenuItem value={"93"}>93</MenuItem>
                        <MenuItem value={"105"}>105</MenuItem>
                        <MenuItem value={"120"}>120</MenuItem>
                        <MenuItem value={"120+"}>120+</MenuItem>
                        <MenuItem value={"43"}>43-жен</MenuItem>
                        <MenuItem value={"47"}>47-жен</MenuItem>
                        <MenuItem value={"52"}>52-жен</MenuItem>
                        <MenuItem value={"57"}>57-жен</MenuItem>
                        <MenuItem value={"63"}>63-жен</MenuItem>
                        <MenuItem value={"69"}>69-жен</MenuItem>
                        <MenuItem value={"72"}>72-жен</MenuItem>
                        <MenuItem value={"76"}>76-жен</MenuItem>
                        <MenuItem value={"84"}>84-жен</MenuItem>
                        <MenuItem value={"84+"}>84+жен</MenuItem>
                      </Select>
                    </FormControl>
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={(e) => setBench(e.target.value)}
                      onfo
                      id="bench"
                      label="Соревновательный присед"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={bench_error}
                      value={bench}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={bench_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={(e) => setPress(e.target.value)}
                      onfo
                      id="number-basic"
                      label="Соревновательный жим"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={press_error}
                      value={press}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={press_error_helper_text}
                    />
                  </Item>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={(e) => setDeadlift(e.target.value)}
                      onfo
                      id="deadlift"
                      label="Соревновательная тяга"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={deadlift_error}
                      value={deadlift}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={deadlift_error_helper_text}
                    />
                  </Item>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                  <Item>
                    <TextField
                      onChange={(e) => setSum(e.target.value)}
                      onfo
                      id="sum"
                      label="Соревновательная сумма"
                      variant="outlined"
                      sx={{ width: "100%" }}
                      error={sum_error}
                      value={sum}
                      slotProps={{ inputLabel: { shrink: true } }}
                      helperText={sum_error_helper_text}
                    />
                  </Item>
                </Grid>
              </Grid>
              <Grid size={12}>
                <Item>
                  <Divider>О СЕБЕ, АВАТАР</Divider>
                </Item>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                <Item>
                  <TextField
                    onChange={(e) => setAboutself(e.target.value)}
                    onfo
                    id="aboutself"
                    label="О себе"
                    variant="outlined"
                    sx={{ width: "100%" }}
                    error={false}
                    value={aboutself}
                    slotProps={{ inputLabel: { shrink: true } }}
                    multiline
                    rows={4}
                  />
                </Item>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                <Item display={"flex"}>
                  <Avatar
                    id="avatar"
                    alt="мой аватар"
                    src={avatar}
                    sx={{ width: 100, height: 100 }}
                  />
                </Item>
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <Item>
                  <AvatarEditor onImageChange={setImage} />
                </Item>
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Item>
                  <Divider></Divider>
                </Item>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <Item>
                  <But
                    // sx={{
                    //   backgroundColor: theme.color.main,
                    // }}
                    disabled={but_dis}
                    variant="outlined"
                    onClick={() => Sportsmen()}
                  >
                    Загрузить данные
                  </But>
                </Item>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <Item>
                  <But
                    disabled={but_dis}
                    variant="outlined"
                    onClick={() => Unauthorized()}
                  >
                    Выход из профиля
                  </But>
                </Item>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Lk;
